import React, { useState } from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { setGlobalDealerName } from './globalState';
import brands from './brands';
import BackButton from './BackButton';

function DealerSelect() {
  /*
  This component allows users to select their dealership brand.
  It displays a grid of dealership logos, and users can select one.
  */
  const navigate = useNavigate();
  const [selectedDealer, setSelectedDealer] = useState(null);

  const toggleDealerSelection = (dealer) => {
    setSelectedDealer((prevSelected) =>
      prevSelected?.name === dealer.name ? null : dealer
    );
  };

  const handleSubmit = async () => {
    if (!selectedDealer) {
      alert('Please select a dealership brand.');
      return;
    }
    setGlobalDealerName(selectedDealer.name);
    navigate('/dealer-id');
  };

  return (
    <div className="DealerSelect">
      <h1 className="DealerSelect-title">Select Your Dealership Brand</h1>
      <div className="DealerSelect-grid">
        {brands.map((dealer) => (
          <div
            key={dealer.name}
            className={`DealerSelect-item ${selectedDealer?.name === dealer.name ? 'selected' : ''}`}
            onClick={() => toggleDealerSelection(dealer)}
          >
            <img src={dealer.logo} alt={dealer.name} className="DealerSelect-logo" />
          </div>
        ))}
      </div>
      <button className="DealerSelect-submit" onClick={handleSubmit}>
        Submit
      </button>
      <BackButton />
    </div>
  );
}

export default DealerSelect;
